'use client';

import { parseUserAgent } from '@diritto/common/utils/userAgent';
import { useInAppState } from 'contexts/InAppProvider';
import { ResultPage } from 'app/(appHeader)/promotions/2026-pick-and-choo/result/ResultPage';

export default function Page() {
  const { userAgent } = useInAppState();
  const { isApp } = parseUserAgent(userAgent ?? '');
  return <ResultPage isApp={isApp} />;
}
